import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useActionToast } from '@/Hooks/useActionToast';
import { bumpTourVersion } from '../Services/Tours.service';
import { toursQueryKeys } from '../Constants/queryKeys';

export const useBumpTourVersion = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: bumpTourVersion,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: toursQueryKeys.lists() });
      queryClient.invalidateQueries({ queryKey: toursQueryKeys.details() });
      toast.success('Revisão do tour subida');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível subir a revisão do tour', error);
    },
  });
};
